import React from 'react';
import { useTranslation } from 'react-i18next';
import './Terms.css';

const PrivateTerms = ({ onAccept, onCancel }) => {
  const { t } = useTranslation();

  return (
    <>
      <h1 className="terms-title">{t('terms.private.title')}</h1>
      
      <section className="terms-section">
        <h2>{t('terms.private.introduction.title')}</h2>
        <p>
          {t('terms.private.introduction.content')}
        </p>
      </section>

      <section className="terms-section">
        <h2>{t('terms.private.collaboration.title')}</h2>
        <ul>
          <li>{t('terms.private.collaboration.item1')}</li>
          <li>{t('terms.private.collaboration.item2')}</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>{t('terms.private.confidentiality.title')}</h2>
        <ul>
          <li>{t('terms.private.confidentiality.item1')}</li>
          <li>{t('terms.private.confidentiality.item2')}</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>{t('terms.private.intellectual.title')}</h2>
        <ul>
          <li>{t('terms.private.intellectual.item1')}</li>
          <li>{t('terms.private.intellectual.item2')}</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>{t('terms.private.warranties.title')}</h2>
        <ul>
          <li>{t('terms.private.warranties.item1')}</li>
          <li>{t('terms.private.warranties.item2')}</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>{t('terms.private.termination.title')}</h2>
        <ul>
          <li>{t('terms.private.termination.item1')}</li>
          <li>{t('terms.private.termination.item2')}</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>{t('terms.private.compensation.title')}</h2>
        <ul>
          <li>{t('terms.private.compensation.item1')}</li>
          <li>{t('terms.private.compensation.item2')}</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>{t('terms.private.compliance.title')}</h2>
        <ul>
          <li>{t('terms.private.compliance.item1')}</li>
          <li>{t('terms.private.compliance.item2')}</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>{t('terms.private.acceptance.title')}</h2>
        <ul>
          <li>{t('terms.private.acceptance.item')}</li>
        </ul>
      </section>

      <div className="terms-footer">
        <p>{t('terms.lastUpdate')} {new Date().toLocaleDateString()}</p>
        <div className="terms-buttons">
          <button 
            className="terms-button accept"
            onClick={onAccept}
          >
            {t('terms.buttons.accept')}
          </button>
          <button 
            className="terms-button cancel"
            onClick={onCancel}
          >
            {t('terms.buttons.cancel')}
          </button>
        </div>
      </div>
    </>
  );
};

export default PrivateTerms; 